/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetPositionSpecialistTeamDto } from './GetPositionSpecialistTeamDto';
import {
    GetPositionSpecialistTeamDtoFromJSON,
    GetPositionSpecialistTeamDtoFromJSONTyped,
    GetPositionSpecialistTeamDtoToJSON,
} from './GetPositionSpecialistTeamDto';

/**
 * 
 * @export
 * @interface GetUmpPositionDto
 */
export interface GetUmpPositionDto {
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    uid: string;
    /**
     * 
     * @type {Date}
     * @memberof GetUmpPositionDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetUmpPositionDto
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    positionName?: string;
    /**
     * 
     * @type {number}
     * @memberof GetUmpPositionDto
     */
    positionSysNum?: number;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    positionNamePok?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    positionType?: GetUmpPositionDtoPositionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetUmpPositionDto
     */
    countryMarketSysNum?: number;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetUmpPositionDto
     */
    countryMarket?: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetUmpPositionDto
     */
    pathPhaseDict?: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    specialistTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    specialistTeamName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    deliveryTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    deliveryTeamName?: string;
    /**
     * 
     * @type {Array<GetPositionSpecialistTeamDto>}
     * @memberof GetUmpPositionDto
     */
    positionSpecialistTeams?: Array<GetPositionSpecialistTeamDto>;
    /**
     * 
     * @type {number}
     * @memberof GetUmpPositionDto
     */
    purchaseFormSysNum?: number;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetUmpPositionDto
     */
    purchaseForm?: GetDictionaryDto;
    /**
     * 
     * @type {number}
     * @memberof GetUmpPositionDto
     */
    formatSysNum?: number;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetUmpPositionDto
     */
    format?: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    qualifiedMedium?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    salesNet?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    rcSalesTotal?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    salesDiscountPercent?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    salesCommissionAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    salesBeerTax?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    pokProjectNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpPositionDto
     */
    mediaplanUid?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetUmpPositionDto
     */
    errors?: { [key: string]: string; };
}


/**
 * @export
 */
export const GetUmpPositionDtoPositionTypeEnum = {
    Standard: 'Standard',
    Commission: 'Commission',
    TransferredCommission: 'TransferredCommission',
    TechnicalCost: 'TechnicalCost'
} as const;
export type GetUmpPositionDtoPositionTypeEnum = typeof GetUmpPositionDtoPositionTypeEnum[keyof typeof GetUmpPositionDtoPositionTypeEnum];


/**
 * Check if a given object implements the GetUmpPositionDto interface.
 */
export function instanceOfGetUmpPositionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uid" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;

    return isInstance;
}

export function GetUmpPositionDtoFromJSON(json: any): GetUmpPositionDto {
    return GetUmpPositionDtoFromJSONTyped(json, false);
}

export function GetUmpPositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUmpPositionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': json['uid'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'positionName': !exists(json, 'positionName') ? undefined : json['positionName'],
        'positionSysNum': !exists(json, 'positionSysNum') ? undefined : json['positionSysNum'],
        'positionNamePok': !exists(json, 'positionNamePok') ? undefined : json['positionNamePok'],
        'positionType': !exists(json, 'positionType') ? undefined : json['positionType'],
        'countryMarketSysNum': !exists(json, 'countryMarketSysNum') ? undefined : json['countryMarketSysNum'],
        'countryMarket': !exists(json, 'countryMarket') ? undefined : GetDictionaryDtoFromJSON(json['countryMarket']),
        'pathPhaseDict': !exists(json, 'pathPhaseDict') ? undefined : GetDictionaryDtoFromJSON(json['pathPhaseDict']),
        'specialistTeamId': !exists(json, 'specialistTeamId') ? undefined : json['specialistTeamId'],
        'specialistTeamName': !exists(json, 'specialistTeamName') ? undefined : json['specialistTeamName'],
        'deliveryTeamId': !exists(json, 'deliveryTeamId') ? undefined : json['deliveryTeamId'],
        'deliveryTeamName': !exists(json, 'deliveryTeamName') ? undefined : json['deliveryTeamName'],
        'positionSpecialistTeams': !exists(json, 'positionSpecialistTeams') ? undefined : ((json['positionSpecialistTeams'] as Array<any>).map(GetPositionSpecialistTeamDtoFromJSON)),
        'purchaseFormSysNum': !exists(json, 'purchaseFormSysNum') ? undefined : json['purchaseFormSysNum'],
        'purchaseForm': !exists(json, 'purchaseForm') ? undefined : GetDictionaryDtoFromJSON(json['purchaseForm']),
        'formatSysNum': !exists(json, 'formatSysNum') ? undefined : json['formatSysNum'],
        'format': !exists(json, 'format') ? undefined : GetDictionaryDtoFromJSON(json['format']),
        'qualifiedMedium': !exists(json, 'qualifiedMedium') ? undefined : json['qualifiedMedium'],
        'salesNet': !exists(json, 'salesNet') ? undefined : json['salesNet'],
        'rcSalesTotal': !exists(json, 'rcSalesTotal') ? undefined : json['rcSalesTotal'],
        'salesDiscountPercent': !exists(json, 'salesDiscountPercent') ? undefined : json['salesDiscountPercent'],
        'salesCommissionAmount': !exists(json, 'salesCommissionAmount') ? undefined : json['salesCommissionAmount'],
        'salesBeerTax': !exists(json, 'salesBeerTax') ? undefined : json['salesBeerTax'],
        'pokProjectNumber': !exists(json, 'pokProjectNumber') ? undefined : json['pokProjectNumber'],
        'mediaplanUid': !exists(json, 'mediaplanUid') ? undefined : json['mediaplanUid'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}

export function GetUmpPositionDtoToJSON(value?: GetUmpPositionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
        'positionName': value.positionName,
        'positionSysNum': value.positionSysNum,
        'positionNamePok': value.positionNamePok,
        'positionType': value.positionType,
        'countryMarketSysNum': value.countryMarketSysNum,
        'countryMarket': GetDictionaryDtoToJSON(value.countryMarket),
        'pathPhaseDict': GetDictionaryDtoToJSON(value.pathPhaseDict),
        'specialistTeamId': value.specialistTeamId,
        'specialistTeamName': value.specialistTeamName,
        'deliveryTeamId': value.deliveryTeamId,
        'deliveryTeamName': value.deliveryTeamName,
        'positionSpecialistTeams': value.positionSpecialistTeams === undefined ? undefined : ((value.positionSpecialistTeams as Array<any>).map(GetPositionSpecialistTeamDtoToJSON)),
        'purchaseFormSysNum': value.purchaseFormSysNum,
        'purchaseForm': GetDictionaryDtoToJSON(value.purchaseForm),
        'formatSysNum': value.formatSysNum,
        'format': GetDictionaryDtoToJSON(value.format),
        'qualifiedMedium': value.qualifiedMedium,
        'salesNet': value.salesNet,
        'rcSalesTotal': value.rcSalesTotal,
        'salesDiscountPercent': value.salesDiscountPercent,
        'salesCommissionAmount': value.salesCommissionAmount,
        'salesBeerTax': value.salesBeerTax,
        'pokProjectNumber': value.pokProjectNumber,
        'mediaplanUid': value.mediaplanUid,
        'errors': value.errors,
    };
}

